module.exports = __webpack_public_path__ + "img/four1Green.7b92c3c4.png";